import { faCheckCircle, faExclamationTriangle, faInfoCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
export const NOTIFICATION_TYPE_ICON = {
    info: faInfoCircle,
    success: faCheckCircle,
    warning: faExclamationTriangle,
    error: faTimesCircle
};
export const NOTIFICATION_TYPE_SCHEMA = {
    info: {
        variant: 'soft',
        schema: 'info',
        state: 'default'
    },
    success: {
        variant: 'soft',
        schema: 'positive',
        state: 'default'
    },
    warning: {
        variant: 'soft',
        schema: 'notice',
        state: 'default'
    },
    error: {
        variant: 'soft',
        schema: 'negative',
        state: 'default'
    }
};
//# sourceMappingURL=Notification.constants.js.map